import React, { Component } from 'react'
import api from "../../config/api";
import { withStyles } from "@material-ui/core/styles";
import { Box } from '@material-ui/core';
import InputAccountBank from '../../components/InputAccountBank';
import InputRange from '../../components/InputRange';
import InputDateRange from '../../components/InputDateRange';
import SelectItem from '../../components/SelectItem';
import CheckboxDefault from '../CheckboxDefault';
import { Search } from '@material-ui/icons/';
import Constants from '../../helper/resources/Constants';
import Messages from '../../helper/resources/Messages';
import { Button } from '@material-ui/core';
import { dateIsValid } from '../../helper/convertDate';
import { getDocumentType, isValidDocument, normalizeDocument } from '../../helper/document';
import validationPermission from '../../helper/validationPermission';


const styles = (theme) => ({
  main: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      margin: "10px 0 20px 0",
    }
  },
  boxFilters: {
    background: '#fff',
    padding: 15,
    width: '-webkit-fill-available',
  },
  flex: {
    width: '100%',
    display: 'flex',
  },
  cleanFilter: {
    color: '#1874B9',
    fontSize: 14,
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  searchBox: {
    background: '#1874B9',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 158,
  },
  searchIcon: {
    color: '#fff',
    width: 45,
    height: 45,
  },
  divValor: {
    // paddingTop: '3px',
  },
  divFiltroContribuinte: {
    width: 'min-content',
    marginRight: '15px',
  },
  divPeriodo: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  divTipoTributo: {
    width: 'min-content',
    marginRight: '22px',
  },
  divCheckBox: {
    display: 'flex',
    alignItems: 'flex-end',
  }
})

const initialState = {
  loadingDebits: null,
  formsValidationError: false,
  obterOcultados: "",
  codigoTributo: "",
  codigoEventoLancamento: "",
  valorMinimo: "",
  valorMaximo: "",
  dataInicio: "",
  dataFim: "",
  vincendo: false,
  vencido: false,
  exigibilidadeSuspensa: false,
  keyClear: 0,
}

class FilterDebitsManager extends Component {
  constructor(props) {
    super(props);
    this.getTiposTributos = this.getTiposTributos.bind(this);
    this.searchButton = React.createRef();

    this.state = {
      ...initialState,
      loadingDebits: this.props.LoadingDebits,
      listTiposTributos: [],
      tipoDocumentoContribuinte: "",
      numeroContribuinte: "",
    }
  }

  componentDidMount() {
    this.getTiposTributos()
    this.submitOnEnter(true)
  }

  componentWillUnmount() {
    this.submitOnEnter(false)
  }

  componentDidUpdate(prevProps) {
    if (this.props.LoadingDebits !== prevProps.LoadingDebits) {
      this.setState({
        loadingDebits: this.props.LoadingDebits
      })
    }

    return null
  }

  async getTiposTributos() {
    try {
      const getTiposTributosResponse = await api.get("Gestao/ObterTiposTributos")

      let lstTiposTributos = []

      if (getTiposTributosResponse.data !== null && getTiposTributosResponse.data !== undefined) {
        if (getTiposTributosResponse.data.EhValida) {
          lstTiposTributos = getTiposTributosResponse.data.Retorno

          // lstTiposTributos.forEach(item => {
          // })
        } else {

        }

        this.setState({
          listTiposTributos: lstTiposTributos
        })
      }
    } catch (error) {

      this.setState({
        // errorMessage: errorMessage,
      });
    }
  }

  getContribuinteTyped = (item) => {
    let tipoDocumento = ''

    if (item !== undefined && item !== null && item !== '')
      tipoDocumento = getDocumentType(item)

    this.setState({
      tipoDocumentoContribuinte: tipoDocumento,
      numeroContribuinte: normalizeDocument(item),
    });
  }

  getInputRange = (min, max) => {

    this.setState({
      valorMinimo: min !== '' ? parseFloat(min.replace('R$', '').replace('.', '').replace(',', '.')) : '',
      valorMaximo: max !== '' ? parseFloat(max.replace('R$', '').replace('.', '').replace(',', '.')) : '',
    })
  }

  getInputDateRange = (dateMin, dateMax) => {

    this.setState({
      dataInicio: dateMin,
      dataFim: dateMax,
    })
  }

  getSelectedTribute = (item) => {

    this.setState({
      codigoTributo: item.CodigoReceita,
      codigoEventoLancamento: item.CodigoEventoLancamento,
    })
  }

  getCheckboxSelected = (name, isChecked) => {

    switch (name) {
      case Constants.SOMENTE_VINCENDO:
        this.setState({
          vincendo: isChecked,
        });
        break;
      case Constants.SOMENTE_VENCIDO:
        this.setState({
          vencido: isChecked,
        });
        break;
      case Constants.SOMENTE_EXIGIBILIDADE_SUSPENSA:
        this.setState({
          exigibilidadeSuspensa: isChecked,
        });
        break;
      default:
        break;
    }
  }

  handleSearchClick = () => {
    this.setState({ keyClear: 0 })
    let filterParams = this.state
    let validationResult = this.validateFilter()

    this.props.GetDebtsManager(filterParams, validationResult)
  }

  validateFilter = () => {
    let validation = {
      isValid: true,
      errorMessage: ''
    }
    let formsError = false

    if (this.state.numeroContribuinte !== null && this.state.numeroContribuinte !== '' &&
      !isValidDocument(this.state.numeroContribuinte)) {
      validation.isValid = false
      validation.errorMessage = Messages.CAMPO_CONTRIBUINTE_INVALIDO
      formsError = true
    }

    if (this.state.dataInicio !== null && this.state.dataInicio !== '') {
      let invalidDate = !dateIsValid(this.state.dataInicio)

      if (invalidDate) {
        validation.isValid = false
        validation.errorMessage = Messages.CAMPO_PERIODO_INVALIDO
        formsError = true
      }
    }

    if (this.state.dataFim !== null && this.state.dataFim !== '') {
      let invalidDate = !dateIsValid(this.state.dataFim)

      if (invalidDate) {
        validation.isValid = false
        validation.errorMessage = Messages.CAMPO_PERIODO_INVALIDO
        formsError = true
      }
    }

    if (this.props.HasRequiredFields && !normalizeDocument(this.state.numeroContribuinte)) {
      validation.isValid = false
      validation.errorMessage = Messages.CAMPO_CONTRIBUINTE_OBRIGATORIO
      formsError = true
    }

    this.setState({
      formsValidationError: formsError
    })

    return validation
  }

  clearFilters = () => {
    this.setState({
      ...initialState,
      keyClear: this.state.keyClear + 1,
    }, () => {
      this.filterDebitsUser()
      this.setState({ keyClear: 0 })
    })
  }

  filterDebitsUser() {
    let filterParams = this.state
    let validationResult = this.validateFilter()

    this.props.GetDebtsManager(filterParams, validationResult)
  }

  submitOnEnter(mounting) {
    const listener = event => {
      if (event.code === "Enter" || event.code === "NumpadEnter") {
        this.searchButton.current.focus()
        this.handleSearchClick()
      }
    };

    if (mounting) {
      document.addEventListener("keydown", listener);
    } else {
      document.removeEventListener("keydown", listener);
    }
  }

  render() {
    const { classes, user } = this.props;
    const { loadingDebits, formsValidationError } = this.state;
    const isContribuinteRequired = this.props.HasRequiredFields;

    return (
      <div className={classes.main} id="divFilters">
        <div className={classes.boxFilters}>
          <Box display="flex" justifyContent="flex-end">
            <span className={classes.cleanFilter} onClick={this.clearFilters}>
              Limpar Filtros
            </span>
          </Box>

          <div className={classes.flex}>
            <div id="divContribuinte" className={classes.divFiltroContribuinte}>
              <InputAccountBank
                inputType={isContribuinteRequired ? 6 : 9}
                getContribuinteTyped={this.getContribuinteTyped}
                error={formsValidationError}
                inputValue={this.state.numeroContribuinte}
              />
            </div>

            <div
              style={{ display: "flex" }}
              key={`filtro-debito-gestor${this.state.keyClear}`}
            >
              <div id="divValor" className={classes.divValor}>
                <InputRange
                  getInputRange={this.getInputRange}
                  clearAll={this.state.clearAll}
                  inputValueMin={this.state.valorMinimo}
                  inputValueMax={this.state.valorMaximo}
                />
              </div>

              <div id="divPeriodo" className={classes.divPeriodo}>
                <InputDateRange
                  getInputDateRange={this.getInputDateRange}
                  clearAll={this.state.clearAll}
                  inputValueMin={this.state.dataInicio}
                  inputValueMax={this.state.dataFim}
                />
              </div>
            </div>
          </div>
          <div className={classes.flex} style={{ marginTop: 10 }}>
            <div
              style={{ display: "flex" }}
              key={`filtro-debito-gestor${this.state.keyClear}`}
            >
              <div id="divTipoTributoId" className={classes.divTipoTributo}>
                <SelectItem
                  typeSelect={2}
                  optionsList={this.state.listTiposTributos}
                  getSelectedTribute={this.getSelectedTribute}
                  clearAll={this.state.clearAll}
                />
              </div>

              {/* <div id="divFiltroCheck" className={classes.divTipoTributo}>
              <SelectItem typeSelect={3} clearAll={this.state.clearAll} />
            </div> */}

              <div id="divCheckBoxesId" className={classes.divCheckBox}>
                <CheckboxDefault
                  getCheckboxSelected={this.getCheckboxSelected}
                  checkboxName={Constants.SOMENTE_VINCENDO}
                  clearAll={this.state.clearAll}
                />

                <CheckboxDefault
                  getCheckboxSelected={this.getCheckboxSelected}
                  checkboxName={Constants.SOMENTE_VENCIDO}
                  clearAll={this.state.clearAll}
                />

                { validationPermission(user,"UC010") && (
                  <CheckboxDefault
                    getCheckboxSelected={this.getCheckboxSelected}
                    checkboxName={Constants.SOMENTE_EXIGIBILIDADE_SUSPENSA}
                    clearAll={this.state.clearAll}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <Button
          id="btnSubmitSearch"
          ref={this.searchButton}
          //variant="primary"
          disabled={loadingDebits}
          onClick={!loadingDebits ? this.handleSearchClick : null}
          classes={{ root: classes.searchBox }}
        >
          <Search className={classes.searchIcon} />
        </Button>

        {/* <div className={classes.searchBox}>
          <Search className={classes.searchIcon} />
        </div> */}
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(FilterDebitsManager)
